import { useEffect, useState } from 'react'
import { CircularProgress } from '@mui/material'
import axios from 'axios'
import ReactGA from 'react-ga4'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { AppConstants, LeadStage } from 'AppConstants/AppConstants'
import Footer from 'components/Footer'
import useLockBodyScroll from 'hooks/useLockBodyScroll'
import useQueryParams from 'hooks/useQueryParams'
import {
  SetChannelSignUp,
  SetAvailablePlansSignUp,
  SetPaymentDoneSignUp,
  SetTimeLeftToExpireSignUp,
  SetSlotBookedAlreadySignUp,
  SetVisitCountSignUp,
  SetIsMoreThanOneStudioSignUp,
  SetSelectedPlanSignUp,
  SetLeadTypeSignUp,
  SetSelectedSlotSignUp,
  SetTimeLeftSignUp,
  SetSlotNotFoundSignUp,
  SetPurchasedPlanSignUp,
  SetSelectedStudioSignUp,
  SetStudiosSignUp,
  SetFirstNameSignUp,
  SetTrackerCountSignUp,
  SetPhoneNumberSignUp,
  SetFormattedPhoneNumberSignUp,
  SetReferralCodeSignUp,
  SetUserIdSignUp,
} from 'redux/SignUp/persist'
import { useAppDispatch, useAppSelector } from 'redux/store'
import { createNavigateWithQueryParams } from 'utils/navigateWithQueryParams'
import styles from './SignUp.module.scss'

const HomeSignUp = () => {
  const { getAllParams, getParams, hasCampaign, hasContent } = useQueryParams()
  const id = getParams('utm_campaign')
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [amount, setAmount] = useState(0)
  const [isLoading, setIsLoading] = useState(true)
  const timeLeft = useAppSelector((state) => state.signUpPersist.timeLeftSignUp)
  // Create reusable navigation function
  const navigateWithQueryParams = createNavigateWithQueryParams(navigate, getAllParams)

  useLockBodyScroll()
  console.log(getAllParams(), 'getAllParams')

  // Function to calculate tracker count based on query params logic

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
  }

  async function getPlans() {
    try {
      const response: any = await axios.get(`${AppConstants.API_URL}/payment-plan/public?campaign=${id}`, {
        headers: {
          'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
        },
      })

      console.log(response, 'res res')
      if (response && response?.data && response?.data?.data) {
        setIsLoading(false)
        setAmount(response.data.data[0]?.amount)
      } else if (response?.data?.statusCode === 401) {
        setIsLoading(false)
        console.log('error')
      }
    } catch (error) {
      setIsLoading(false)
      console.error(error)
    }
  }

  async function getStudioCount() {
    try {
      const response: any = await axios.get(`${AppConstants.API_URL}/operator/clinics/public`, {
        headers: {
          'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
        },
      })

      if (response && response?.data && response?.data?.data) {
        if (response.data.data > 1) {
          dispatch(SetIsMoreThanOneStudioSignUp(true))
        } else {
          dispatch(SetIsMoreThanOneStudioSignUp(false))
        }
      } else if (response?.data?.statusCode === 401) {
        console.log('error')
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    dispatch(SetTimeLeftSignUp(timeLeft ?? 299))
  }, [])

  useEffect(() => {
    if (timeLeft && timeLeft > 0) {
      const timerId = setInterval(() => {
        dispatch(SetTimeLeftSignUp(timeLeft - 1))
      }, 1000)

      return () => clearInterval(timerId)
    }
  }, [timeLeft])

  useEffect(() => {
    if (hasCampaign) {
      getPlans()
    } else {
      setIsLoading(false)
    }
    getStudioCount()
    ReactGA.event('page_view', {
      page_title: 'SignUp|Home',
      page_location: `/signup/${id}`,
    })
  }, [])

  useEffect(() => {
    localStorage.setItem(AppConstants.USER_FIRST_NAME, '')
    localStorage.setItem(AppConstants.USER_EMAIL, '')

    dispatch(SetSelectedPlanSignUp(null))
    dispatch(SetSelectedSlotSignUp(null))
    dispatch(SetAvailablePlansSignUp(null))
    dispatch(SetSlotBookedAlreadySignUp(false))
    dispatch(SetSlotNotFoundSignUp(false))
    dispatch(SetPurchasedPlanSignUp(null))
    dispatch(SetVisitCountSignUp(null))
    dispatch(SetPaymentDoneSignUp(false))
    dispatch(SetTimeLeftToExpireSignUp(null))
    dispatch(SetSelectedStudioSignUp(null))
    dispatch(SetStudiosSignUp([]))
    dispatch(SetIsMoreThanOneStudioSignUp(false))
    dispatch(SetLeadTypeSignUp(null))
    dispatch(SetFirstNameSignUp(''))
    dispatch(SetChannelSignUp(''))
    dispatch(SetPhoneNumberSignUp(''))
    dispatch(SetUserIdSignUp(''))
    dispatch(SetFormattedPhoneNumberSignUp(''))
    dispatch(SetReferralCodeSignUp(''))
    dispatch(SetTrackerCountSignUp(0))
    dispatch(SetTimeLeftToExpireSignUp(null))
    dispatch(SetSelectedPlanSignUp(null))
    dispatch(SetSelectedSlotSignUp(null))
    dispatch(SetAvailablePlansSignUp(null))
    dispatch(SetSlotBookedAlreadySignUp(false))
    dispatch(SetSlotNotFoundSignUp(false))
    dispatch(SetPurchasedPlanSignUp(null))
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerText}>
          <span>{'BOOK YOUR FIRST '}</span>
          <span>{`ADJUSTMENT AT KIRO.`}</span>
        </div>
        <img src={'/logo2.png'} alt="logo" className={styles.logo} />
      </div>

      <div className={styles.content}>
        {isLoading && (
          <div className={styles.circularProgress}>
            <CircularProgress
              size={40}
              sx={{
                color: '#007F7C',
                width: '14px',
                height: '14px',
              }}
            />
          </div>
        )}

        {!isLoading && (
          <div className={styles.textContainer}>
            <div className={styles.messageText}>
              <span>Join thousands of New Yorkers living</span>
              <br></br>
              <span>pain-free with care from NYC's</span>
              <br></br>
              <span>highest-rated chiropractic brand.</span>
            </div>
            <div className={styles.offerDetails}>
              <div>
                <img src="/images/tickBlack.svg"></img>
                <span style={{ marginLeft: '7px' }}>Includes: exam + total spinal adjustment</span>
              </div>
              {hasCampaign && (
                <div>
                  <img src="/images/tickBlack.svg"></img>
                  <span style={{ marginLeft: '7px' }}>
                    {amount === 0 ? 'Free!' : `$${amount / 100} New Patient Special`}
                  </span>
                </div>
              )}
              <div>
                <img src="/images/tickBlack.svg"></img>
                <span style={{ marginLeft: '7px' }}>2,000+ 5-Star Google reviews</span>
              </div>
              <div>
                <img src="/images/tickBlack.svg"></img>
                <span style={{ marginLeft: '7px' }}>Book in under 1 minute</span>
              </div>
              {hasCampaign && (
                <div>
                  <img src="/images/tickBlack.svg"></img>
                  <span style={{ marginLeft: '7px' }}>Limited-time offer</span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <Footer
        buttonText={hasCampaign ? `Claim Your Special Offer` : `Book Your Adjustment`}
        isLoading={false}
        trackerIndex={10}
        isDisabled={false}
        buttonType={'button'}
        showHelpSmsLink
        aboveButtons={
          hasCampaign ? (
            <div className={styles.offerExpires}>
              Offer Expires In: <span className={styles.timer}>{formatTime(timeLeft || 0)}</span>
            </div>
          ) : undefined
        }
        secondaryButtonText={'Watch Intro Video'}
        onSecondaryButtonClick={() => {
          navigateWithQueryParams('/intro')
        }}
        onButtonClick={() => {
          navigateWithQueryParams('/signup/name')
        }}
      ></Footer>
    </div>
  )
}

export default HomeSignUp
